import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography } from '@mui/material';
import DonutChart from './DonutChart';
import DonutChartTimeDuration from './DonutChartTimeDuration';
import { useState, useEffect } from "react";

const TextDonut = (props) => {
    //console.log("IN TextDonutCHART I AM IN");

    return (
        <>
            {(props.widgetprop.type=='text_donut') && <DonutChart widgetprop={props.widgetprop} />}
            {(props.widgetprop.type=='text_donut_time_duration') && <DonutChartTimeDuration widgetprop={props.widgetprop} />}
        </>
    );
};

export default TextDonut;

